import axios from "axios";
import { API_ENDPOINTS } from './endpoints';

export const getSoldOutProducts = async () => {
  const url = `${process.env.REACT_APP_BASE_PATH}${API_ENDPOINTS.SOLDOUT_PRODUCTS}`;
  const { data } = await axios.get(url, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return data;
};
